import angular from 'angular';
import uiRouter from 'angular-ui-router';
import episodelistComponent from './episodelist.component';

let episodelistModule = angular.module('episodelist', [
  uiRouter
])

.component('episodelist', episodelistComponent);

export default episodelistModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/episodelist/episodelist.js